export function toFormattedAddress(address: {
  street: string
  unit?: string
  city: string
  state: string
  zip: string
}): string {
  const { street, unit, city, state, zip } = address

  const trimmedStreet = street.trim()
  const trimmedUnit = unit?.trim()
  const trimmedCity = city.trim()
  const trimmedState = state.trim().toUpperCase()
  const trimmedZip = zip.trim()

  const streetLine = trimmedUnit
    ? `${trimmedStreet} ${trimmedUnit}`
    : trimmedStreet

  return `${streetLine}, ${trimmedCity}, ${trimmedState} ${trimmedZip}`
}
